var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import NoteTypeService from "../../src/Services/NoteType.service";
/**
 * This lookup should only be used for reporting as it no longer has permission restrictions on the service call
 */
const NoteTypeLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            return NoteTypeService.findByIds(ids);
        },
        fetchOptions: (query) => __awaiter(void 0, void 0, void 0, function* () {
            const { data } = yield NoteTypeService.searchAll({
                query,
                active: true,
            });
            return data;
        }),
        optionRenderer: function optionRenderer(noteType) {
            return _jsx("span", { children: noteType.name });
        },
    });
};
export default NoteTypeLookup;
